import { Box, styled } from '@material-ui/core';

export const SuccessContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: 32,
  textAlign: 'center',
  paddingLeft: 24,
  paddingRight: 24,
});

export const IllustrationWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  width: 184,
  height: 184,
  background: 'color-mix(in srgb, #F9CAC9 32%, transparent)',
  borderRadius: '50%',
  marginBottom: 16,
});

export const Illustration = styled('img')({
  width: 96,
});
